'use client';

import { ReactNode } from 'react';

import { getBackgroundRarityStyle, tw } from '../../utils';

interface BadgeProps {
  tier: string;
  count: ReactNode | number;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  tier,
  count,
  className,
}: BadgeProps) => {
  return (
    <div
      className={tw(
        tier === 'unselected' ? 'bg-white' : getBackgroundRarityStyle(tier),
        'absolute rounded-full',
        'h-10 w-max min-w-[40px]',
        tier === 'unselected' ? '-right-2 -top-2' : '-right-4 -top-4',
        className,
      )}
    >
      <div
        style={{
          strokeWidth: '2px',
          stroke: '#FFF',
          boxShadow:
            '3.928px 3.928px 25.531px 0px rgba(255, 255, 255, 0.05) inset, 0px 0.982px 0px 0px rgba(255, 255, 255, 0.15) inset',
          filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
        }}
        className={tw(
          tier !== 'unselected' ? 'bg-black/25' : 'bg-black',
          'absolute inset-0.5 rounded-full backdrop-blur-[2px]',
          'flex items-center justify-center',
        )}
      >
        <p
          className={tw(
            getBackgroundRarityStyle(tier),
            'text-white',
            'text-md bg-clip-text font-semibold',
          )}
        >
          {count}
        </p>
      </div>
    </div>
  );
};
